// src/utils/districts.ts

// Define arrays with explicit typing
const rural: string[] = [
  "香港特别行政区葵青区",
  "香港特别行政区大埔区",
  "香港特别行政区元朗区",
  "香港特别行政区屯门区",
  "香港特别行政区荃湾区",
  "香港特别行政区沙田区",
  "香港特别行政区北区",
  "香港特别行政区观塘区",
  "香港特别行政区黄大仙区",
  "香港特别行政区九龙城区",
  "香港特别行政区深水埗区",
  "香港特别行政区油尖旺区",
];

const urban: string[] = [
  "香港特别行政区中西区",
  "香港特别行政区湾仔区",
  "香港特别行政区东区",
  "香港特别行政区南区",
];

const sz1: string[] = ["广东省深圳市罗湖区", "广东省深圳市福田区"];
const sz2: string[] = ["广东省深圳市宝安区", "广东省深圳市盐田区", "广东省深圳市龙华区", "广东省深圳市南山区"];
const sz3: string[] = ["广东省深圳市龙岗区"];
const sz4: string[] = ["广东省深圳市坪山区", "广东省深圳市光明区"];
const zs1: string[] = ["广东省中山市"];
const dg1: string[] = ["广东省东莞市"];
const jm1: string[] = ["广东省江门市江海区", "新会区", "蓬江区"];
const jm2: string[] = ["广东省江门市台山市", "广东省江门市开平市", "广东省江门市鹤山市"];
const jm3: string[] = ["广东省江门市恩平市"];
const mo1: string[] = [
  "澳门特别行政区花王堂区",
  "澳门特别行政区花地玛堂区",
  "澳门特别行政区望德堂区",
  "澳门特别行政区大堂区",
  "澳门特别行政区风顺堂区",
  "澳门特别行政区嘉模堂区",
  "澳门特别行政区路凼填海区",
  "澳门特别行政区圣方济各堂区",
];
const zh1: string[] = ["广东省珠海市香洲区"];
const zh2: string[] = ["广东省珠海市金湾区", "广东省珠海市斗门区"];
const fs1: string[] = ["广东省佛山市顺德区"];
const fs2: string[] = ["广东省佛山市南海区", "广东省佛山市禅城区"];
const fs3: string[] = ["广东省佛山市高明区", "广东省佛山市三水区"];
const gz1: string[] = ["广东省广州市南沙区"];
const gz2: string[] = ["广东省广州市番禺区"];
const gz3: string[] = ["广东省广州市天河区", "广东省广州市海珠区", "广东省广州市越秀区", "广东省广州市荔湾区"];
const gz4: string[] = ["广东省广州市白云区", "广东省广州市花都区", "广东省广州市黄埔区", "广东省广州市增城区"];
const gz5: string[] = ["广东省广州市从化区"];
const hz1: string[] = ["广东省惠州市惠阳区"];
const hz2: string[] = ["广东省惠州市惠城区"];
const hz3: string[] = ["广东省惠州市博罗县"];
const hz4: string[] = ["广东省惠州市惠东县"];
const hz5: string[] = ["广东省惠州市龙门县"];
const zq1: string[] = ["广东省肇庆市端州区", "广东省肇庆市鼎湖区", "广东省肇庆市四会市", "广东省肇庆市高要区"];
const zq2: string[] = ["广东省肇庆市广宁县"];
const zq3: string[] = ["广东省肇庆市封开县", "广东省肇庆市德庆县", "广东省肇庆市怀集县"];

// Function to calculate distance/priority
export const getDistance = (district: string[]): number => {
  if (
    (rural.includes(district[0]) && sz1.includes(district[1])) ||
    (rural.includes(district[1]) && sz1.includes(district[0]))
  ) {
    return 1;
  } else if (
    (rural.includes(district[0]) && sz2.includes(district[1])) ||
    (rural.includes(district[1]) && sz2.includes(district[0]))
  ) {
    return 2;
  } else if (
    (rural.includes(district[0]) && sz3.includes(district[1])) ||
    (rural.includes(district[1]) && sz3.includes(district[0]))
  ) {
    return 3;
  } else if (
    (rural.includes(district[0]) && sz4.includes(district[1])) ||
    (rural.includes(district[1]) && sz4.includes(district[0]))
  ) {
    return 4;
  } else if (
    (rural.includes(district[0]) && zs1.includes(district[1])) ||
    (rural.includes(district[1]) && zs1.includes(district[0]))
  ) {
    return 5;
  } else if (
    (rural.includes(district[0]) && dg1.includes(district[1])) ||
    (rural.includes(district[1]) && dg1.includes(district[0]))
  ) {
    return 6;
  } else if (
    (rural.includes(district[0]) && jm1.includes(district[1])) ||
    (rural.includes(district[1]) && jm1.includes(district[0]))
  ) {
    return 7;
  } else if (
    (rural.includes(district[0]) && jm2.includes(district[1])) ||
    (rural.includes(district[1]) && jm2.includes(district[0]))
  ) {
    return 8;
  } else if (
    (rural.includes(district[0]) && jm3.includes(district[1])) ||
    (rural.includes(district[1]) && jm3.includes(district[0]))
  ) {
    return 9;
  } else if (
    (rural.includes(district[0]) && mo1.includes(district[1])) ||
    (rural.includes(district[1]) && mo1.includes(district[0]))
  ) {
    return 10;
  } else if (
    (rural.includes(district[0]) && zh1.includes(district[1])) ||
    (rural.includes(district[1]) && zh1.includes(district[0]))
  ) {
    return 11;
  } else if (
    (rural.includes(district[0]) && zh2.includes(district[1])) ||
    (rural.includes(district[1]) && zh2.includes(district[0]))
  ) {
    return 12;
  } else if (
    (rural.includes(district[0]) && fs1.includes(district[1])) ||
    (rural.includes(district[1]) && fs1.includes(district[0]))
  ) {
    return 13;
  } else if (
    (rural.includes(district[0]) && fs2.includes(district[1])) ||
    (rural.includes(district[1]) && fs2.includes(district[0]))
  ) {
    return 14;
  } else if (
    (rural.includes(district[0]) && fs3.includes(district[1])) ||
    (rural.includes(district[1]) && fs3.includes(district[0]))
  ) {
    return 15;
  } else if (
    (rural.includes(district[0]) && gz1.includes(district[1])) ||
    (rural.includes(district[1]) && gz1.includes(district[0]))
  ) {
    return 16;
  } else if (
    (rural.includes(district[0]) && gz2.includes(district[1])) ||
    (rural.includes(district[1]) && gz2.includes(district[0]))
  ) {
    return 17;
  } else if (
    (rural.includes(district[0]) && gz3.includes(district[1])) ||
    (rural.includes(district[1]) && gz3.includes(district[0]))
  ) {
    return 18;
  } else if (
    (rural.includes(district[0]) && gz4.includes(district[1])) ||
    (rural.includes(district[1]) && gz4.includes(district[0]))
  ) {
    return 19;
  } else if (
    (rural.includes(district[0]) && gz5.includes(district[1])) ||
    (rural.includes(district[1]) && gz5.includes(district[0]))
  ) {
    return 20;
  } else if (
    (rural.includes(district[0]) && hz1.includes(district[1])) ||
    (rural.includes(district[1]) && hz1.includes(district[0]))
  ) {
    return 21;
  } else if (
    (rural.includes(district[0]) && hz2.includes(district[1])) ||
    (rural.includes(district[1]) && hz2.includes(district[0]))
  ) {
    return 22;
  } else if (
    (rural.includes(district[0]) && hz3.includes(district[1])) ||
    (rural.includes(district[1]) && hz3.includes(district[0]))
  ) {
    return 23;
  } else if (
    (rural.includes(district[0]) && hz4.includes(district[1])) ||
    (rural.includes(district[1]) && hz4.includes(district[0]))
  ) {
    return 24;
  } else if (
    (rural.includes(district[0]) && hz5.includes(district[1])) ||
    (rural.includes(district[1]) && hz5.includes(district[0]))
  ) {
    return 25;
  } else if (
    (rural.includes(district[0]) && zq1.includes(district[1])) ||
    (rural.includes(district[1]) && zq1.includes(district[0]))
  ) {
    return 26;
  } else if (
    (rural.includes(district[0]) && zq2.includes(district[1])) ||
    (rural.includes(district[1]) && zq2.includes(district[0]))
  ) {
    return 27;
  } else if (
    (rural.includes(district[0]) && zq3.includes(district[1])) ||
    (rural.includes(district[1]) && zq3.includes(district[0]))
  ) {
    return 28;
  } else if (
    (urban.includes(district[0]) && sz1.includes(district[1])) ||
    (urban.includes(district[1]) && sz1.includes(district[0]))
  ) {
    return 29;
  } else if (
    (urban.includes(district[0]) && sz2.includes(district[1])) ||
    (urban.includes(district[1]) && sz2.includes(district[0]))
  ) {
    return 30;
  } else if (
    (urban.includes(district[0]) && sz3.includes(district[1])) ||
    (urban.includes(district[1]) && sz3.includes(district[0]))
  ) {
    return 31;
  } else if (
    (urban.includes(district[0]) && sz4.includes(district[1])) ||
    (urban.includes(district[1]) && sz4.includes(district[0]))
  ) {
    return 32;
  } else if (
    (urban.includes(district[0]) && zs1.includes(district[1])) ||
    (urban.includes(district[1]) && zs1.includes(district[0]))
  ) {
    return 33;
  } else if (
    (urban.includes(district[0]) && dg1.includes(district[1])) ||
    (urban.includes(district[1]) && dg1.includes(district[0]))
  ) {
    return 34;
  } else if (
    (urban.includes(district[0]) && jm1.includes(district[1])) ||
    (urban.includes(district[1]) && jm1.includes(district[0]))
  ) {
    return 35;
  } else if (
    (urban.includes(district[0]) && jm2.includes(district[1])) ||
    (urban.includes(district[1]) && jm2.includes(district[0]))
  ) {
    return 36;
  } else if (
    (urban.includes(district[0]) && jm3.includes(district[1])) ||
    (urban.includes(district[1]) && jm3.includes(district[0]))
  ) {
    return 37;
  } else if (
    (urban.includes(district[0]) && mo1.includes(district[1])) ||
    (urban.includes(district[1]) && mo1.includes(district[0]))
  ) {
    return 38;
  } else if (
    (urban.includes(district[0]) && zh1.includes(district[1])) ||
    (urban.includes(district[1]) && zh1.includes(district[0]))
  ) {
    return 39;
  } else if (
    (urban.includes(district[0]) && zh2.includes(district[1])) ||
    (urban.includes(district[1]) && zh2.includes(district[0]))
  ) {
    return 40;
  } else if (
    (urban.includes(district[0]) && fs1.includes(district[1])) ||
    (urban.includes(district[1]) && fs1.includes(district[0]))
  ) {
    return 41;
  } else if (
    (urban.includes(district[0]) && fs2.includes(district[1])) ||
    (urban.includes(district[1]) && fs2.includes(district[0]))
  ) {
    return 42;
  } else if (
    (urban.includes(district[0]) && fs3.includes(district[1])) ||
    (urban.includes(district[1]) && fs3.includes(district[0]))
  ) {
    return 43;
  } else if (
    (urban.includes(district[0]) && gz1.includes(district[1])) ||
    (urban.includes(district[1]) && gz1.includes(district[0]))
  ) {
    return 44;
  } else if (
    (urban.includes(district[0]) && gz2.includes(district[1])) ||
    (urban.includes(district[1]) && gz2.includes(district[0]))
  ) {
    return 45;
  } else if (
    (urban.includes(district[0]) && gz3.includes(district[1])) ||
    (urban.includes(district[1]) && gz3.includes(district[0]))
  ) {
    return 46;
  } else if (
    (urban.includes(district[0]) && gz4.includes(district[1])) ||
    (urban.includes(district[1]) && gz4.includes(district[0]))
  ) {
    return 47;
  } else if (
    (urban.includes(district[0]) && gz5.includes(district[1])) ||
    (urban.includes(district[1]) && gz5.includes(district[0]))
  ) {
    return 48;
  } else if (
    (urban.includes(district[0]) && hz1.includes(district[1])) ||
    (urban.includes(district[1]) && hz1.includes(district[0]))
  ) {
    return 49;
  } else if (
    (urban.includes(district[0]) && hz2.includes(district[1])) ||
    (urban.includes(district[1]) && hz2.includes(district[0]))
  ) {
    return 50;
  } else if (
    (urban.includes(district[0]) && hz3.includes(district[1])) ||
    (urban.includes(district[1]) && hz3.includes(district[0]))
  ) {
    return 51;
  } else if (
    (urban.includes(district[0]) && hz4.includes(district[1])) ||
    (urban.includes(district[1]) && hz4.includes(district[0]))
  ) {
    return 52;
  } else if (
    (urban.includes(district[0]) && hz5.includes(district[1])) ||
    (urban.includes(district[1]) && hz5.includes(district[0]))
  ) {
    return 53;
  } else if (
    (urban.includes(district[0]) && zq1.includes(district[1])) ||
    (urban.includes(district[1]) && zq1.includes(district[0]))
  ) {
    return 54;
  } else if (
    (urban.includes(district[0]) && zq2.includes(district[1])) ||
    (urban.includes(district[1]) && zq2.includes(district[0]))
  ) {
    return 55;
  } else if (
    (urban.includes(district[0]) && zq3.includes(district[1])) ||
    (urban.includes(district[1]) && zq3.includes(district[0]))
  ) {
    return 56;
  } else if (
    (district[0].includes("西贡") && sz1.includes(district[1])) ||
    (district[1].includes("西贡") && sz1.includes(district[0]))
  ) {
    return 57;
  } else if (
    (district[0].includes("西贡") && sz2.includes(district[1])) ||
    (district[1].includes("西贡") && sz2.includes(district[0]))
  ) {
    return 58;
  } else if (
    (district[0].includes("西贡") && sz3.includes(district[1])) ||
    (district[1].includes("西贡") && sz3.includes(district[0]))
  ) {
    return 59;
  } else if (
    (district[0].includes("西贡") && sz4.includes(district[1])) ||
    (district[1].includes("西贡") && sz4.includes(district[0]))
  ) {
    return 60;
  } else if (
    (district[0].includes("西贡") && zs1.includes(district[1])) ||
    (district[1].includes("西贡") && zs1.includes(district[0]))
  ) {
    return 61;
  } else if (
    (district[0].includes("西贡") && dg1.includes(district[1])) ||
    (district[1].includes("西贡") && dg1.includes(district[0]))
  ) {
    return 62;
  } else if (
    (district[0].includes("西贡") && jm1.includes(district[1])) ||
    (district[1].includes("西贡") && jm1.includes(district[0]))
  ) {
    return 63;
  } else if (
    (district[0].includes("西贡") && jm2.includes(district[1])) ||
    (district[1].includes("西贡") && jm2.includes(district[0]))
  ) {
    return 64;
  } else if (
    (district[0].includes("西贡") && jm3.includes(district[1])) ||
    (district[1].includes("西贡") && jm3.includes(district[0]))
  ) {
    return 65;
  } else if (
    (district[0].includes("西贡") && mo1.includes(district[1])) ||
    (district[1].includes("西贡") && mo1.includes(district[0]))
  ) {
    return 66;
  } else if (
    (district[0].includes("西贡") && zh1.includes(district[1])) ||
    (district[1].includes("西贡") && zh1.includes(district[0]))
  ) {
    return 67;
  } else if (
    (district[0].includes("西贡") && zh2.includes(district[1])) ||
    (district[1].includes("西贡") && zh2.includes(district[0]))
  ) {
    return 68;
  } else if (
    (district[0].includes("西贡") && fs1.includes(district[1])) ||
    (district[1].includes("西贡") && fs1.includes(district[0]))
  ) {
    return 69;
  } else if (
    (district[0].includes("西贡") && fs2.includes(district[1])) ||
    (district[1].includes("西贡") && fs2.includes(district[0]))
  ) {
    return 70;
  } else if (
    (district[0].includes("西贡") && fs3.includes(district[1])) ||
    (district[1].includes("西贡") && fs3.includes(district[0]))
  ) {
    return 71;
  } else if (
    (district[0].includes("西贡") && gz1.includes(district[1])) ||
    (district[1].includes("西贡") && gz1.includes(district[0]))
  ) {
    return 72;
  } else if (
    (district[0].includes("西贡") && gz2.includes(district[1])) ||
    (district[1].includes("西贡") && gz2.includes(district[0]))
  ) {
    return 73;
  } else if (
    (district[0].includes("西贡") && gz3.includes(district[1])) ||
    (district[1].includes("西贡") && gz3.includes(district[0]))
  ) {
    return 74;
  } else if (
    (district[0].includes("西贡") && gz4.includes(district[1])) ||
    (district[1].includes("西贡") && gz4.includes(district[0]))
  ) {
    return 75;
  } else if (
    (district[0].includes("西贡") && gz5.includes(district[1])) ||
    (district[1].includes("西贡") && gz5.includes(district[0]))
  ) {
    return 76;
  } else if (
    (district[0].includes("西贡") && hz1.includes(district[1])) ||
    (district[1].includes("西贡") && hz1.includes(district[0]))
  ) {
    return 77;
  } else if (
    (district[0].includes("西贡") && hz2.includes(district[1])) ||
    (district[1].includes("西贡") && hz2.includes(district[0]))
  ) {
    return 78;
  } else if (
    (district[0].includes("西贡") && hz3.includes(district[1])) ||
    (district[1].includes("西贡") && hz3.includes(district[0]))
  ) {
    return 79;
  } else if (
    (district[0].includes("西贡") && hz4.includes(district[1])) ||
    (district[1].includes("西贡") && hz4.includes(district[0]))
  ) {
    return 80;
  } else if (
    (district[0].includes("西贡") && hz5.includes(district[1])) ||
    (district[1].includes("西贡") && hz5.includes(district[0]))
  ) {
    return 81;
  } else if (
    (district[0].includes("西贡") && zq1.includes(district[1])) ||
    (district[1].includes("西贡") && zq1.includes(district[0]))
  ) {
    return 82;
  } else if (
    (district[0].includes("西贡") && zq2.includes(district[1])) ||
    (district[1].includes("西贡") && zq2.includes(district[0]))
  ) {
    return 83;
  } else if (
    (district[0].includes("西贡") && zq3.includes(district[1])) ||
    (district[1].includes("西贡") && zq3.includes(district[0]))
  ) {
    return 84;
  } else if (
    (district[0].includes("离岛") && sz1.includes(district[1])) ||
    (district[1].includes("离岛") && sz1.includes(district[0]))
  ) {
    return 85;
  } else if (
    (district[0].includes("离岛") && sz2.includes(district[1])) ||
    (district[1].includes("离岛") && sz2.includes(district[0]))
  ) {
    return 86;
  } else if (
    (district[0].includes("离岛") && sz3.includes(district[1])) ||
    (district[1].includes("离岛") && sz3.includes(district[0]))
  ) {
    return 87;
  } else if (
    (district[0].includes("离岛") && sz4.includes(district[1])) ||
    (district[1].includes("离岛") && sz4.includes(district[0]))
  ) {
    return 88;
  } else if (
    (district[0].includes("离岛") && zs1.includes(district[1])) ||
    (district[1].includes("离岛") && zs1.includes(district[0]))
  ) {
    return 89;
  } else if (
    (district[0].includes("离岛") && dg1.includes(district[1])) ||
    (district[1].includes("离岛") && dg1.includes(district[0]))
  ) {
    return 90;
  } else if (
    (district[0].includes("离岛") && jm1.includes(district[1])) ||
    (district[1].includes("离岛") && jm1.includes(district[0]))
  ) {
    return 91;
  } else if (
    (district[0].includes("离岛") && jm2.includes(district[1])) ||
    (district[1].includes("离岛") && jm2.includes(district[0]))
  ) {
    return 92;
  } else if (
    (district[0].includes("离岛") && jm3.includes(district[1])) ||
    (district[1].includes("离岛") && jm3.includes(district[0]))
  ) {
    return 93;
  } else if (
    (district[0].includes("离岛") && mo1.includes(district[1])) ||
    (district[1].includes("离岛") && mo1.includes(district[0]))
  ) {
    return 94;
  } else if (
    (district[0].includes("离岛") && zh1.includes(district[1])) ||
    (district[1].includes("离岛") && zh1.includes(district[0]))
  ) {
    return 95;
  } else if (
    (district[0].includes("离岛") && zh2.includes(district[1])) ||
    (district[1].includes("离岛") && zh2.includes(district[0]))
  ) {
    return 96;
  } else if (
    (district[0].includes("离岛") && fs1.includes(district[1])) ||
    (district[1].includes("离岛") && fs1.includes(district[0]))
  ) {
    return 97;
  } else if (
    (district[0].includes("离岛") && fs2.includes(district[1])) ||
    (district[1].includes("离岛") && fs2.includes(district[0]))
  ) {
    return 98;
  } else if (
    (district[0].includes("离岛") && fs3.includes(district[1])) ||
    (district[1].includes("离岛") && fs3.includes(district[0]))
  ) {
    return 99;
  } else if (
    (district[0].includes("离岛") && gz1.includes(district[1])) ||
    (district[1].includes("离岛") && gz1.includes(district[0]))
  ) {
    return 100;
  } else if (
    (district[0].includes("离岛") && gz2.includes(district[1])) ||
    (district[1].includes("离岛") && gz2.includes(district[0]))
  ) {
    return 101;
  } else if (
    (district[0].includes("离岛") && gz3.includes(district[1])) ||
    (district[1].includes("离岛") && gz3.includes(district[0]))
  ) {
    return 102;
  } else if (
    (district[0].includes("离岛") && gz4.includes(district[1])) ||
    (district[1].includes("离岛") && gz4.includes(district[0]))
  ) {
    return 103;
  } else if (
    (district[0].includes("离岛") && gz5.includes(district[1])) ||
    (district[1].includes("离岛") && gz5.includes(district[0]))
  ) {
    return 104;
  } else if (
    (district[0].includes("离岛") && hz1.includes(district[1])) ||
    (district[1].includes("离岛") && hz1.includes(district[0]))
  ) {
    return 105;
  } else if (
    (district[0].includes("离岛") && hz2.includes(district[1])) ||
    (district[1].includes("离岛") && hz2.includes(district[0]))
  ) {
    return 106;
  } else if (
    (district[0].includes("离岛") && hz3.includes(district[1])) ||
    (district[1].includes("离岛") && hz3.includes(district[0]))
  ) {
    return 107;
  } else if (
    (district[0].includes("离岛") && hz4.includes(district[1])) ||
    (district[1].includes("离岛") && hz4.includes(district[0]))
  ) {
    return 108;
  } else if (
    (district[0].includes("离岛") && hz5.includes(district[1])) ||
    (district[1].includes("离岛") && hz5.includes(district[0]))
  ) {
    return 109;
  } else if (
    (district[0].includes("离岛") && zq1.includes(district[1])) ||
    (district[1].includes("离岛") && zq1.includes(district[0]))
  ) {
    return 110;
  } else if (
    (district[0].includes("离岛") && zq2.includes(district[1])) ||
    (district[1].includes("离岛") && zq2.includes(district[0]))
  ) {
    return 111;
  } else if (
      (district[0].includes("离岛") && zq3.includes(district[1])) ||
      (district[1].includes("离岛") && zq3.includes(district[0]))
    ) {
      return 112;
    } else {
      return 0;
    }
};